/**
 * The support address shown to distributor users.
 *
 * One constant rather than a per-partner registry entry: distributors are a small,
 * single-support-queue audience, and the two copies that existed before this (the
 * Support page's mailto and its link text) are exactly how wording drifts apart.
 */
export const SUPPORT_EMAIL = "support@viaads.com";
